import { useEffect } from 'react'

import Api from 'services/api'

import { useStoreContext } from 'hooks/StoreContext'

const useAlertDescriptions = () => {
  const { alertDescriptions, setAlertDescriptions, areAlertDescriptionsLoaded, setAreAlertDescriptionsLoaded } = useStoreContext()

  useEffect(() => {
    if (areAlertDescriptionsLoaded) {
      return
    }

    setAlertDescriptions(null)
    setAreAlertDescriptionsLoaded(false)

    Api.AlertDescriptions.list()
      .then(res => {
        setAlertDescriptions(res)
      })
      .catch(() => {

      })
      .finally(() => {
        setAreAlertDescriptionsLoaded(true)
      })
  }, [areAlertDescriptionsLoaded, setAlertDescriptions, setAreAlertDescriptionsLoaded])

  return { alertDescriptions, areAlertDescriptionsLoaded }
}

export default useAlertDescriptions
